/**
 * 引数がnullまたはundefinedであればtrueを返す。
 *
 * `value == null` でも全く同じことができる: https://stackoverflow.com/a/5515385/12579447
 * が、イコールの数を数えるのが面倒だし、きっとそのうち間違えるので、テンプレート外ではこの関数を推奨する。
 */
export function isNullish<T>(value: T | null | undefined): value is null | undefined {
  return value === null || value === undefined;
}
